import React from "react";

import Sidebar from "../sidebar/sidebar";

import useSidebarSettingsStore from "@/store/sidebarSettingsStore";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isCollapsed } = useSidebarSettingsStore();
  return (
    <div className="layout max-h-16">
      <div className="content-container">
        <Sidebar />
        <main className={`main-content ${isCollapsed ? "expanded" : ""}`}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
